import React from 'react';
import { useDarkMode } from '../../DarkModeContext'; // Adjust the import path as needed

const Loading = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <div className="flex flex-col items-center justify-center h-64">
      <div className="loader">
        <style jsx>{`
          .loader {
            animation: rotate 1s infinite;
            height: 50px;
            width: 50px;
          }
          .loader:before,
          .loader:after {
            border-radius: 50%;
            content: "";
            display: block;
            height: 20px;
            width: 20px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .loader:before {
            animation: ball1 1s infinite;
            background-color: ${isDarkMode ? '#fff' : '#000'};
            box-shadow: 30px 0 0 #f46524, 0 2px 4px rgba(0, 0, 0, 0.1);
            margin-bottom: 10px;
          }
          .loader:after {
            animation: ball2 1s infinite;
            background-color: #f46524;
            box-shadow: 30px 0 0 ${isDarkMode ? '#fff' : '#000'}, 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          @keyframes rotate {
            0% { transform: rotate(0deg) scale(0.8) }
            50% { transform: rotate(360deg) scale(1.2) }
            100% { transform: rotate(720deg) scale(0.8) }
          }
          @keyframes ball1 {
            0% { box-shadow: 30px 0 0 #f46524, 0 2px 4px rgba(0, 0, 0, 0.1); }
            50% { box-shadow: 0 0 0 #f46524, 0 2px 4px rgba(0, 0, 0, 0.1); margin-bottom: 0; transform: translate(15px, 15px); }
            100% { box-shadow: 30px 0 0 #f46524, 0 2px 4px rgba(0, 0, 0, 0.1); margin-bottom: 10px; }
          }
          @keyframes ball2 {
            0% { box-shadow: 30px 0 0 ${isDarkMode ? '#fff' : '#000'}, 0 2px 4px rgba(0, 0, 0, 0.1); }
            50% { box-shadow: 0 0 0 ${isDarkMode ? '#fff' : '#000'}, 0 2px 4px rgba(0, 0, 0, 0.1); margin-top: -20px; transform: translate(15px, 15px); }
            100% { box-shadow: 30px 0 0 ${isDarkMode ? '#fff' : '#000'}, 0 2px 4px rgba(0, 0, 0, 0.1); margin-top: 0; }
          }
        `}</style>
      </div>
      <p className="mt-4 text-lg font-semibold text-black-700 dark:text-gray-300">Loading...</p>
    </div>
  );
};

export default Loading;